/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Deck_Library_CountInputs */



/**
* | output |
* | --- |
* | "Library ({count})" |
*
* @param {Deck_Library_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_library_count = /** @type {((inputs: Deck_Library_CountInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Library_CountInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Bibliothèque (${i?.count})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Biblioteca (${i?.count})`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Biblioteca (${i?.count})`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Biblioteca (${i?.count})`)
	return /** @type {LocalizedString} */ (`Library (${i?.count})`)
});